import * as React from 'react'
import {connect} from 'react-redux'

import RunningBuildUpdater from '../../../containers/RunningBuildUpdater'
import type {State} from '../../../reducers/types'
import {getBuild} from '../../../selectors'

import BuildTimeInfo from './BuildTimeInfo'
import type {Props, OwnProps, StateProps} from './BuildTimeInfo.types'

const mapStateToProps = (state: State, props: OwnProps): StateProps => {
  const {
    startDate,
    finishDate,
    ['running-info']: runningInfo,
  } = getBuild(state, props.buildId) ?? {}
  const {elapsedSeconds} = runningInfo ?? {}
  return {
    startDate,
    finishDate,
    elapsedSeconds,
  }
}

function BuildTimeInfoContainer(props: Props) {
  const {subscribe, ...restProps} = props
  return (
    <React.Fragment>
      {subscribe === true && <RunningBuildUpdater buildId={props.buildId} />}
      <BuildTimeInfo {...restProps} />
    </React.Fragment>
  )
}

export default connect(mapStateToProps)(BuildTimeInfoContainer)
